import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MementoService {
  private mementos: any[] = [];
  private currentState = 0;
  private orginator:any;
  public canUndo = new BehaviorSubject(false);
  public canRedo = new BehaviorSubject(false);

  constructor() {}

  setOriginator(object:any){
    this.orginator = object;
    this.currentState = 0;
    this.mementos = [];
    this.mementos.push(JSON.parse(JSON.stringify(object)));
    this.canRedo.next(false);
    this.canUndo.next(false);
  }

  create(state: any) {
    //console.log('Current state is ' + this.currentState);
    //console.log('Current memento length is ' + this.mementos.length);
    //console.log('Current mementos are ')
   // console.log(this.mementos);

    // delete any redo options
    if(this.mementos.length>this.currentState+1){
      this.mementos.length = this.currentState+1;
    }
    this.currentState++;
    this.mementos.push(JSON.parse(JSON.stringify(state)));

    this.canUndo.next(true);
    this.canRedo.next(false);

    

   // console.log('After state is ' + this.currentState);
   // console.log('After memento length is ' + this.mementos.length);
   // console.log('After mementos are ')
   // console.log(this.mementos);
  }

  restore(index: number) {
    this.currentState = index;
    return this.mementos[index];
  }

  undo() {
    //console.log('UNDO FROM ' + this.currentState);
    if (this.currentState > 0) {
      this.currentState--;

      this.canRedo.next(true);
      return JSON.parse(JSON.stringify(this.mementos[this.currentState]));
    }
    else{
      this.canUndo.next(false);
    }
  }

  redo() {
    if (this.currentState < this.mementos.length-1) {
      this.currentState++;
      this.canUndo.next(true);
      return JSON.parse(JSON.stringify(this.mementos[this.currentState]));
    }
    else{
      this.canRedo.next(false);
    }
  }

  clear(){
    this.orginator = null;
    this.mementos = [];
  }
}
